// extracted by mini-css-extract-plugin
module.exports = {"signIn":"LoginMessage_signIn__1Ua4o","message":"LoginMessage_message__lKtut"};